import * as Constants from '../constants/';

const initialState = {
  isLoading: true,
  isActivating: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_ACTIVATION_STATUS:
      return { ...state, isLoading: true };
    case Constants.REQUEST_ACTIVATE:
      return { ...state, isActivating: true };
    case Constants.REQUEST_READONLY:
      return { ...state, isToggling: true };
    case Constants.RECEIVE_ACTIVATION_STATUS:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      return {
        ...state,
        isLoading: false,
        status: action.data.status
      };
    case Constants.RECEIVE_ACTIVATE:
      if (action.error) {
        return { ...state, isActivating: false, error: action.error };
      }
      return {
        ...state,
        isActivating: false,
        status: action.data.status
      };
    case Constants.RECEIVE_READONLY:
      if (action.error) {
        return { ...state, isToggling: false, error: action.error };
      }
      return {
        ...state,
        isToggling: false,
        status: action.data.status
      };
    default:
      return state;
  }
}
